import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { DebugLogProvider, isDebugPanelEnabled } from './debug';
import type { ChatMessage } from './types/messages';
import type { UserInfo } from './types/user';
import TripAiMessagesPage from './TripAiMessagesPage';

type LocationState = {
  initialMessage?: string;
};

interface Props {
  match: { params: { id: string } };
  user: UserInfo;
}

const TripAiMessagesRoot = ({ match, user }: Props) => {
  const location = useLocation<LocationState>();
  const tripId = match.params.id;

  // 実際には現時点では使ってない。カレンダーなど外部のリンクからメッセージを伴ってAIチャットを行う場合
  const initialMessage = useMemo(() => {
    return location.state?.initialMessage;
  }, [location.state]);

  const initialMessages: ChatMessage[] = useMemo(() => {
    if (initialMessage === undefined) return [];
    return [
      {
        id: `initial-${tripId}`,
        direction: 'user',
        text: initialMessage,
        createdAt: new Date().toISOString(),
        feedbackCommentSubmitted: false
      },
      {
        id: `optimistic-${tripId}`,
        direction: 'ai',
        text: '応答を生成中です...',
        createdAt: new Date().toISOString(),
        type: 'optimistic',
        feedbackCommentSubmitted: false
      }
    ];
  }, [initialMessage, tripId]);

  const debugEnabled = isDebugPanelEnabled();

  return (
    <DebugLogProvider tripId={tripId} enabled={debugEnabled}>
      <TripAiMessagesPage
        tripId={tripId}
        user={user}
        initialMessage={initialMessage}
        initialMessages={initialMessages}
      />
    </DebugLogProvider>
  );
};

export default TripAiMessagesRoot;
